export type ProjectionScenario = "bad" | "mid" | "good";

export const PROJECTION_SCENARIO_SELECT_OPTIONS: Array<{
  value: ProjectionScenario;
  label: string;
}> = [
  { value: "good", label: "Good Scenario" },
  { value: "mid", label: "Mid Scenario" },
  { value: "bad", label: "Bad Scenario" },
];
